import React, { useState } from 'react';
import { Layout as AntLayout, Menu, Avatar, Dropdown, Button, Typography } from 'antd';
import {
  HomeOutlined,
  UserOutlined,
  AuditOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  GlobalOutlined,
  DatabaseOutlined,
  DollarOutlined,
  AppstoreOutlined,
  BankOutlined,
  ClockCircleOutlined,
  EditOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const { Header, Sider, Content } = AntLayout;
const { Title } = Typography;

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const userData = user.data;
  const navigate = useNavigate();
  const location = useLocation();

  // Menu items based on user role
  const getMenuItems = () => {
    const items = [
      {
        key: '/',
        icon: <HomeOutlined />,
        label: 'Home',
        onClick: () => navigate('/'),
      },
      {
        key: '/costing-rules',
        icon: <DatabaseOutlined />,
        label: 'All COGS Rules',
        onClick: () => navigate('/costing-rules'),
      },
      {
        key: '/pending-approvals',
        icon: <ClockCircleOutlined />,
        label: 'Pending Approvals',
        onClick: () => navigate('/pending-approvals'),
      },
      {
        key: '/draft-rules',
        icon: <EditOutlined />,
        label: 'Draft Rules',
        onClick: () => navigate('/draft-rules'),
      },
    ];

    // Add audit trail for admin users only
    if (userData?.role === 'Admin') {
      items.push({
        key: '/audit',
        icon: <AuditOutlined />,
        label: 'Audit Trail',
        onClick: () => navigate('/audit'),
      });
    }

    // Add admin-only menus
    if (userData?.role === 'Admin') {
      items.push({
        key: 'admin-management',
        icon: <DatabaseOutlined />,
        label: 'Admin',
        children: [
          {
            key: '/admin/users',
            icon: <UserOutlined />,
            label: 'Users',
            onClick: () => navigate('/admin/users'),
          },
          {
            key: '/admin/currencies',
            icon: <DollarOutlined />,
            label: 'Currencies',
            onClick: () => navigate('/admin/currencies'),
          },
          {
            key: '/admin/pricing-schemes',
            icon: <AppstoreOutlined />,
            label: 'Pricing Schemes',
            onClick: () => navigate('/admin/pricing-schemes'),
          },
          {
            key: '/admin/products',
            icon: <AppstoreOutlined />,
            label: 'Products',
            onClick: () => navigate('/admin/products'),
          },
          {
            key: '/admin/entities',
            icon: <BankOutlined />,
            label: 'Transaction Entities',
            onClick: () => navigate('/admin/entities'),
          },
          {
            key: '/admin/channels',
            icon: <GlobalOutlined />,
            label: 'Channels',
            onClick: () => navigate('/admin/channels'),
          },
        ],
      });
    }

    return items;
  };

  // User dropdown menu
  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
    },
  ];

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        style={{
          background: '#fff',
          boxShadow: '2px 0 8px 0 rgba(29,35,41,.05)',
        }}
      >
        <div style={{ 
          padding: '16px', 
          textAlign: 'center',
          borderBottom: '1px solid #f0f0f0'
        }}>
          {!collapsed ? (
            <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
              COGS Management
            </Title>
          ) : (
            <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
              CM
            </Title>
          )}
        </div>
        
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={getMenuItems()}
          style={{ border: 'none' }}
        />
      </Sider>
      
      <AntLayout>
        <Header style={{ 
          padding: '0 16px', 
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 2px 8px 0 rgba(29,35,41,.05)'
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={handleToggle}
            style={{ fontSize: '16px' }}
          />
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ textAlign: 'right', lineHeight: '1.2' }}>
              <div style={{ color: '#333', fontWeight: '500', fontSize: '14px', margin: 0 }}>
                {userData?.email}
              </div>
              <div style={{ color: '#666', fontSize: '12px', margin: 0 }}>
                {userData?.role}
              </div>
            </div>
            <Dropdown
              menu={{ items: userMenuItems }}
              placement="bottomRight"
              trigger={['click']}
            >
              <Avatar
                style={{
                  backgroundColor: '#1890ff',
                  cursor: 'pointer'
                }}
                icon={<UserOutlined />}
              >
                {userData?.email?.charAt(0)?.toUpperCase()}
              </Avatar>
            </Dropdown>
          </div>
        </Header>
        
        <Content style={{ 
          margin: '16px',
          padding: '24px',
          background: '#fff',
          borderRadius: '8px',
          minHeight: 'calc(100vh - 112px)'
        }}>
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
